
import { commonfunc } from '~/mixin/common'

export default {
  name: 'ProdRating',
  mixins: [commonfunc],
  props: {
    revwRank: {
      type: String,
      default: ''
    },
    ordrQyRank: {
      type: String,
      default: ''
    },
    mostRevwYn: {
      type: Boolean,
      default: false
    },
    revwRating: {
      type: Boolean,
      default: false
    },
    revwAvg: {
      type: [String, Number],
      default: ''
    },
    revwCnt: {
      type: String,
      default: ''
    },
    onlyAvg: {
      type: Boolean,
      default: false
    },
    inct: {
      type: Number,
      default: 0
    },
    totalYn: {
      type: Boolean,
      default: false
    },
    totOrQy: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      inctStr: '' // 조회인원수
    }
  },
  computed: {
    getRecStr () {
      // ORDR_QY_RANK  8>최근 주문수 N위,전체 구매 순위 n위 상품이에요

      if (this.ordrQyRank && this.ordrQyRank !== '0') {
        const arr = this.ordrQyRank.split('>')
        if (Number(arr[0]) > 0) {
          const retrunStr = '최근 구매 ' + arr[0] + '위'
          return retrunStr
        } else {
          return '0'
        }
      }

      return '0'
    },
  },
  mounted () {
    this.inctStr = this.inctCnt(this.inct)
  },
  methods: {
    inctCnt (value) {
      let resultStr = 0.0
      if (value >= 100 && value <= 9999) {
        return this.numberComma(Number(value)) + '명 봤어요'
      } else if (value >= 10000 && value <= 999999) {
        resultStr = Math.round(value / 10000 * 10) / 10
        return resultStr.toLocaleString() + '만 봤어요'
      } else if (value > 999999) {
        return '99.9+만 봤어요'
      } else {
        return ''
      }
    },
  }
}
